import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify } from '@fortawesome/free-brands-svg-icons/faSpotify';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

import Link from '@buyside/components/presentation/Link/link';
import { MediaTypes } from '@buyside/components/presentation/MediaShowPage/mediaShowPage';

import { entityUrl, mediaIndexUrlFor, mediaShowUrlFor } from '@buyside/util/urlHelper';

import {
  PodcastEpisodeMediaIndexFragment,
  VideoMediaIndexFragment
} from '@interfaces/graphql-typings';

import styles from './mediaIndexPageStyles.scss';

const MediaIndexItem: React.FC<PodcastEpisodeMediaIndexFragment | VideoMediaIndexFragment> = ({
  __typename,
  description,
  id,
  mentionedEntities,
  publishedAt,
  tagList,
  thumbnailImageUrl,
  title,
  vanityLink
}) => {
  const mediaIndexUrl = mediaIndexUrlFor(`${__typename}`);
  const mediaShowUrl = mediaShowUrlFor(`${__typename}`);

  return (
    <div key={id} className={styles.mediaIndexItem}>
      <Link to={mediaShowUrl(vanityLink || id)}>
        <div className={styles.thumbnail}>
          {thumbnailImageUrl ? <img src={thumbnailImageUrl} /> : null}
          <FontAwesomeIcon
            className={classNames({ [styles.isVideo]: __typename === MediaTypes.VIDEO })}
            icon={__typename === MediaTypes.VIDEO ? faYoutube : faSpotify}
          />
          <p>{publishedAt} ago</p>
        </div>
      </Link>
      <Link to={mediaShowUrl(vanityLink || id)}>{title}</Link>
      {description.length ? <p className={styles.description}>{description}</p> : null}
      {mentionedEntities.length ? (
        <div className={styles.mentionedEntities}>
          {mentionedEntities.map(entity => (
            <Link key={`entity-${entity.id}`} to={entityUrl(entity.id)}>
              {entity.primarySymbol}
            </Link>
          ))}
        </div>
      ) : null}
      {tagList.length ? (
        <div className={styles.tags}>
          {tagList.map(tag => (
            <Link key={`${id}-${tag}`} to={mediaIndexUrl(tag)}>
              #{tag}
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default MediaIndexItem;
